(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('StrainNameSearch', StrainNameSearch);

    StrainNameSearch.$inject = ['$resource'];

    function StrainNameSearch ($resource) {
        var resourceUrl =  '/api/strain-name/:searchString';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        console.log('search results:' + data);
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
